<template>
    <div style="position: relative">

        <loading-overlay :active="pageLoading" :is-full-page="true" :lock-scroll="true" loader="dots" color="#0168b7"
                background-color="#ffffff" opacity="1" />

        <v-app-bar density="compact">
            <v-tabs v-model="activeTab" bg-color="#0168b7" slider-color="#fff" color="#fff" show-arrows grow>
                <v-tab :value="1" :ripple="false">商品について</v-tab>
                <v-tab :value="2" :ripple="false">販売条件</v-tab>
            </v-tabs>
        </v-app-bar>

        <v-window v-model="activeTab">
            <v-window-item :value="1">
                <v-sheet>
                    <v-container>

                        <div class="item-tile">

                            <h2 class="item-tile__title">
                                {{ item.itemName }}
                            </h2>

                            <div class="item-tile__thumbnail item-tile__thumbnail--default rounded-xl">
                                <div class="item-tile__thumbnail__cover" :style="ec_main_bg"></div>
                            </div>

                            <div class="item-tile__partner" @click="onClickedPartner">
                                <div class="partner-icon partner-icon--default">
                                    <div class="partner-icon__cover" :style="partner_main_bg">{{ partner_icon_name }}</div>
                                </div>
                                <div>{{ partner.partnerName }}</div>
                            </div>

                            <div class="item-tile__description">
                                {{ decodeHtmlEscape(item.description) }}
                            </div>

                            <div class="d-flex align-center justify-space-between my-3">
                                <div>販売価格</div>
                                <div class="d-flex align-baseline" style="gap: 4px;">
                                    <div style="font-size: 1.6em;">{{ format_price }}</div>
                                    <div>円</div>
                                </div>                                
                            </div>

                            <div v-if="item.supporter" class="d-flex align-center justify-space-between my-3">
                                <div>購入者数</div>
                                <div class="d-flex align-baseline gradation" style="gap: 4px; font-weight: 600;">
                                    <div style="font-size: 1.6em;">{{ format_supporter }}</div>
                                    <div>人</div>
                                </div>
                            </div>

                            <div class="my-5" style="display: flex; gap: 8px; flex-flow: column;">
                                <div>
                                    <div v-if="item.itemStatus==2 && item.upperLimitSuryo > 0" style="display: flex; align-items: stretch; gap: 8px;">
                                        <div style="width: 30%; min-width: 100px; max-width: 200px;">
                                            <v-select hide-details variant="solo" density="compact" label="数量" :items="upper_suryo" v-model="suryo" filled dense></v-select>
                                        </div>
                                        <div style="width: 70%;">
                                            <v-btn :loading="isCartBusy" block id="id-add-cart" color="primary" variant="elevated" class="rounded-pill" :ripple="false" @click="onClickedCart" style="min-height: 100%;">
                                                <v-icon start icon="mdi-cart-outline" />
                                                <span>カートに入れる</span>
                                            </v-btn>
                                        </div>
                                    </div>
                                    <div v-else>この商品は現在お取り扱いしていません</div>
                                </div>
                            </div>

                            <Transition>
                                <div class="my-7" v-if="viewTogetherItem && togetherItem">
                                    <h2>以下の商品も一緒に購入されています</h2>
                                    <StoreMainTile
                                    :ec_item_id="togetherItem.ec_item_id"
                                    :ec_item_name="togetherItem.item_name"
                                    :description="togetherItem.explanation_short"
                                    :price="togetherItem.price"
                                    :thumbnail="`background-image: url('/data/ec/${togetherItem.ec_item_id}/main.jpg')`" />
                                </div>
                            </Transition>

                            <div class="mt-4" style="display: flex; align-items: center; justify-content: end; gap: 12px;">
                                <SnsShare :url="shareUrl" :align="`right`" />
                                <v-btn :loading="isWatchBusy"
                                        id="id-watch-icon"
                                        :class="{'checked': isWatched}"
                                        background-color="white"
                                        :ripple="false"
                                        variant="text"
                                        icon="mdi-heart"
                                        density="compact"
                                        @click="onClickedWatch"
                                        style="font-size: 24px; margin-bottom: 12px;"
                                >
                                </v-btn>
                            </div>

                            <div v-if="!isCommentEmpty">
                                <h2 class="">購入者の声</h2>
                                <div class="item-tile__comment comment-list">
                                    <template v-for="(comment, $index) in comments" :key="$index">
                                        <UserComment
                                            :user-address="comment.address"
                                            :user-comment="comment.comment"
                                            :comment-date="dateFormat(comment.date)"
                                        />
                                    </template>
                                    <InfiniteLoading @infinite="infiniteCommentsHandler">
                                        <template #complete>
                                            <span> </span>
                                        </template>
                                    </InfiniteLoading>
                                </div>
                            </div>

                            <h2 class="mt-5">商品説明</h2>
                            <fundHtml class="my-5" :htmlDoc="item.detailHtml" />

                            <EcItemListCircle :item_id="itemId" :title="`関連商品`" :endpoint="'/api/ec/category/same'" />

                        </div>
                    </v-container>
                </v-sheet>
            </v-window-item>

            <v-window-item :value="2">
                <v-sheet>
                    <v-container>

                        <div class="order-condition">


                            <div class="order-condition__section order-condition-section">
                                <h3 class="order-condition-section__title">
                                    所在地
                                </h3>
                                <div class="order-condition-section__body">
                                    {{ item.itemOwnerAddress }}
                                </div>
                            </div>

                            <div class="order-condition__section order-condition-section">
                                <h3 class="order-condition-section__title">
                                    お支払方法
                                </h3>
                                <div class="order-condition-section__body">
                                    <p><strong>（１）お振込み</strong></p>
                                    <p>以下の銀行へのお振込みが可能です。<br>
                                    お申込後、当社からお送りする確認のメールに記載の口座へ、以下期日までにお振込をお願い致します。<br>
                                    <img src="/data/common/img/banks_store.gif"></p>
                                    
                                    <p><strong>（２）クレジットカード</strong></p>
                                    <p>VISA、MasterCard、JCB、DinersClub、AMEXのクレジットカードがご利用可能です。<br>
                                    <img src="/data/common/img/cardchoice_s.gif"></p>
                                    
                                    <p><strong>（３）支払留保金のご利用</strong></p>
                                    <p>支払留保金額もご利用頂けます。</p>
                                    <ul class="attention">
                                    <li>※お振込手数料は、ご負担下さい。</li>
                                    <li>※送料は商品代金に含まれます。</li>
                                    <li>※支払留保金額をご利用の際は、申込確認メールに詳細を記載致します。</li>
                                    <li>※クレジットカードをご利用の際は、以下【クレジットカードをご利用頂く場合のご注意】をご確認の上、ご利用下さい。</li>
                                    </ul>
                                </div>
                            </div>

                            <div class="order-condition__section order-condition-section">
                                <h3 class="order-condition-section__title">
                                    お振込期日
                                </h3>
                                <div class="order-condition-section__body">
                                    <p>ご注文受付のメールをお送りしてから3営業日以内にお願い致します。</p>
                                    <ul class="attention">
                                        <li>※必ず期日までにご入金頂きますようお願い申し上げます。ご入金期日を過ぎますと、キャンセルとなりますのでご注意下さい。</li>
                                        <li>※購入代金をお振込頂く際は、必ず期日までに、当社からのメールに記載の口座へお振込頂きますようお願い致します。<br>
                                        万が一出資金お振込口座へご入金をされた際は、返金となりますのでご了承ください。<br>
                                        その際の返金は、振込手数料を除いた額を返金致します。</li>
                                    </ul>
                                </div>
                            </div>

                            <div class="order-condition__section order-condition-section">
                                <h3 class="order-condition-section__title">
                                    クレジットカードをご利用頂く場合のご注意
                                </h3>
                                <div class="order-condition-section__body">
                                    <ul class="attention">
                                        <li>※ご本人様名義のカード以外はご利用頂けません。</li>
                                        <li>※ご決済は一括払いのみご利用頂けます。</li>
                                        <li>※1商品ごとのご決済となりますので、他商品を合わせて購入頂いた場合も、都度ご決済が必要です。（1商品を複数セット購入頂く際は、まとめてご決済頂けます）</li>
                                        <li>※ご購入代金は、各クレジット会員規約に基づき、ご指定の預金口座から口座振替にてお支払いいただきます。</li>
                                        <li>※クレジットカード決済にあたっては、より安全性の高い環境をサービスとして提供するために、暗号化技術（SSL）を使用しておりますが、当社は、その安全性を保証するものではなく、データ漏洩等の事故が起こった場合、当社はその責任を負いかねますのでご了承ください。</li>
                                        <li>※クレジットカードはご注文時に即時決済されるカードとなります。リピート商品など初回ご注文時に複数回の商品代金をいただく場合がございます。また、キャンセル・返品に伴う返金の時期につきましては、お手元のクレジットカード発行会社へお問い合わせください。</li>
                                    </ul>
                                </div>
                            </div>

                        </div>

                    </v-container>
                </v-sheet>
            </v-window-item>

        </v-window>
            
        <div v-if="activeTab > 1" class="cta-container text-center px-5" style="position: fixed; bottom: 88px; width: 100%; display: flex; flex-flow: column; gap: 8px;">
            <v-btn v-if="item.itemStatus==2" id="id-add-cart" color="primary" variant="elevated" class="rounded-pill" :ripple="false" @click="onClickedCart" block>カートに入れる</v-btn>
        </div>

    </div>
</template>

<style scoped>
#id-watch-icon{
    color: #cccccc;
}
#id-watch-icon.checked{
    color: #ff0000;
}
.cta-container .v-btn{
    opacity: 0.8;
}
.cta-container .v-btn:hover{
    opacity: 1;
}

.v-window-item {
    min-height: calc(100vh - 180px);
}
.comment-list{
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    width: 100%;
    max-height: 280px;
    overflow: scroll;
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.comment-list::-webkit-scrollbar{
    display: none;
}

.item-tile {}

.item-tile__title {
    margin: 8px 0;
}

.item-tile__thumbnail {
    margin-top: 8px;
    width: 100%;
    overflow: hidden;
    aspect-ratio: 16 / 9;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}

.item-tile__thumbnail--default {
    background-color: #aaa;
    background-image: url('../assets/images/now_loading_fund_thumb.jpg');
}

.item-tile__thumbnail__cover {
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
}
.item-tile__description {
    margin: 20px 0;
}
.item-tile__partner {
    margin: 20px 0;
    display: flex;
    align-items: center;
    gap: 16px;
}

.item-tile__comment {
}

.partner-icon {
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    width: 60px;
    height: 60px;
    border-radius: 50%;
}

.partner-icon--default {
    background-color: #d3e4ff;
}

.partner-icon__cover {
    width: inherit;
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 1.4rem;
    color: #fff;
}

.order-condition{
    display: flex;
    flex-flow: column;
    gap: 20px;
    padding-bottom: 50px;
}
.order-condition__section{
}
.order-condition-section{
}
.order-condition-section__title{
    margin: 0 0 20px 0;
}
.order-condition-section__body{
}

.order-condition-section__body > *{
    margin: 8px 0;
}

.order-condition-section__body .attention{
    margin-left: 1em;
}

.order-condition-section__body .attention li{
    margin: 4px 0;
    text-indent: -1em;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.v-tab.v-tab {
    opacity: 0.4;
}
.v-tab.v-tab.v-tab--selected {
    opacity: 1;
}
</style>

<script>

import axios from "axios"
import Helper from "../assets/js/helper"
import InfiniteLoading from "v3-infinite-loading"
import "v3-infinite-loading/lib/style.css"
import LoadingOverlay from 'vue3-loading-overlay';
import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
import CommentImage from "../assets/images/supporter.png"
import fundHtml from "../components/fundHtml"
import EcLogic from "../composable/EcLogic"
import SnsShare from "../components/SnsShare.vue"
import UserComment from "../components/UserComment"
import StoreMainTile from "../components/StoreMainTile.vue"
import EcItemListCircle from "../components/EcItemListCircle.vue"

const ecContentApi = '/api/ec/detail'
const commentListApi = '/api/ec/comment/list'
const watchListApi = '/api/watch/item/save'
const addCartApi = '/api/cart/add'

export default {
    components: {
        InfiniteLoading,
        LoadingOverlay,
        fundHtml,
        SnsShare,
        UserComment,
        StoreMainTile,
        EcItemListCircle
    },
    data: () => ({
        'pageLoading': true,
        'suryo': 1,
        'isWatchBusy': false,
        'isCartBusy': false,
        'activeTab': 1,
        'isWatched': false,
        'isCommentEmpty': false,
        'itemId': '',
        'comment_page': 0,
        'item': {
            'itemName': '',
            'itemStatus': 0,
            'description': '',
            'detailHtml': '',
            'price': '',
            'upperLimitSuryo': '',
            'supporter': '',
            'itemOwnerAddress': ''
        },
        'partner': {
            'partnerId': '',
            'partnerName': '',
        },
        comments: [],
        ec_main_bg: {},
        partner_main_bg: {},
        comment_icon_bg: {
            backgroundImage: `url('${CommentImage}')`,
        },
        shareUrl: window.location.href,
        togetherItem: [],
        viewTogetherItem: false,
        partner_icon_name: '',
    }),
    watch: {
        'item.itemName': function(to) {
            if(to){
                this.$store.dispatch('setActivePageTitle', to)
            }
        },
    },
    computed: {
        format_price: function () {
            return Helper.addComma(this.item.price)
        },
        format_supporter: function () {
            return Helper.addComma(this.item.supporter)
        },
        format_status: function () {
            return EcLogic.nameStatus(this.item.itemStatus)
        },
        upper_suryo: function () {
            if(this.item.upperLimitSuryo > 0){
                return [...Array(this.item.upperLimitSuryo)].map((ele, i) => i + 1)
            }
            return [];
        },
        numberItemsInCart: {
            get() {
                return this.$store.getters.numberItemsInCart
            },
            set(value) {
                this.$store.dispatch("setNumberItemsInCart", value);
            }
        },
        flushMessage: {
            set(value) {
                this.$store.dispatch("setFlushMessage", value);
            }
        }
    },
    created: async function () {

        this.itemId = this.$route.query.ecitem_id

        try {

            const response = await axios.get(ecContentApi, {
                params: {
                    item_id: this.itemId
                }
            })

            console.log(response);

            // ファンド系
            this.ec_main_bg = { backgroundImage: `url('/data/ec/${this.itemId}/main.jpg')` };
            this.item.itemName = response.data.item.itemName
            this.item.itemStatus = response.data.item.itemStatus
            this.item.description = response.data.item.description
            this.item.detailHtml = response.data.item.detailHtml
            this.item.price = response.data.item.price
            this.item.supporter = response.data.item.supporter
            this.item.upperLimitSuryo = response.data.item.upperLimitSuryo
            this.item.itemOwnerAddress = response.data.item.itemOwnerAddress 
            
            // 事業者系
            this.partner.partnerName = response.data.partner.partnerName
            this.partner.partnerId = response.data.partner.partnerId
            if(response.data.partner.partnerIconName != ''){
                this.partner_icon_name = response.data.partner.partnerIconName
            }else{
                this.partner_main_bg = { backgroundImage: `url('/data/partner/${this.partner.partnerId}/owner.jpg')` }
            }

            // ステータス系
            this.isWatched = response.data.status.isWatched

            this.$nextTick(() => {
                this.pageLoading = false
            })

            // ページアクセスの保存
            const accessParams = new URLSearchParams();
            accessParams.append('page_id', this.itemId);
            accessParams.append('page_type', 'ec');
            await axios.post('/api/spa/page/access', accessParams).catch(() => {
                return;
            });

        } catch (error) {
            console.log(error)
            this.$router.push('/progressive');
            return;
        }

        //同時購入されている商品
        const res2 = await axios.get('/api/ec/together', {
            params: {item_id: this.itemId}
        }).catch(() => {
            return ;
        })
        this.togetherItem = res2.data
    },
    mounted: function() {},
    methods: {
        dateFormat($date){
            return Helper.formatDate($date)
        },
        onClickedPartner(){
            this.$router.push({ name: 'search', query: {keyword: this.partner.partnerName, type: 'ec'} })
        },
        onClickedCart(){
            (async () => {
                try{
                    this.isCartBusy = true;
                    var params = new URLSearchParams();
                    params.append('item_id', this.itemId);
                    params.append('suryo', this.suryo);
                    const response = await axios.post(addCartApi, params)
                    console.log(response)
                    this.numberItemsInCart = response.data.length

                    this.flushMessage = 'カートに追加しました'
                    
                }catch(error){
                    console.log(error)
                }finally{
                    this.isCartBusy = false;
                    this.viewTogetherItem = true;
                }
            })()

        },
        onClickedWatch(){
            (async () => {
                try{
                    this.isWatchBusy = true;
                    var params = new URLSearchParams();
                    params.append('ec_item_id', this.itemId);
                    params.append('mode', this.isWatched ? 'del' : 'add');
                    const response = await axios.post(watchListApi, params)
                    console.log(response)
                    this.isWatched = !this.isWatched
                    this.flushMessage = this.isWatched ? 'ウォッチリストに登録しました' : 'ウォッチリストを解除しました'
                }catch(error){
                    console.log(error)
                    alert('ウォッチリストの登録に失敗しました。画面右上のリロードボタンからページを更新後、再度お試しください。')
                }finally{
                    this.isWatchBusy = false;
                }
            })()
        },
        async infiniteCommentsHandler($state) {

            const res = await axios.get(commentListApi, {
                params: {
                    item_id: this.itemId,
                    limit: 10,
                    pg: this.comment_page
                }
            }).catch(() => {
                $state.error();
                return;
            });
            
            if (res.data.length > 0) {
                this.comment_page++;
                this.comments.push(...res.data);
                $state.loaded();
            } else {
                $state.complete();
                this.isCommentEmpty = this.comments.length == 0
            }
        },
        decodeHtmlEscape(string){
            return Helper.decodeHtmlEscape(string)
        }
    }
}
</script>